import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistoryCteResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistoryCteResponse(value));

const isHistoryCteAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleHistoryCteError = (xhr, reject, rejectMessage) => {
  if (isHistoryCteAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxHistoryCteEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  encodeDd = true,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('cte'),
        [routeField]: encodeRoute ? base64_encode(ll) : ll,
        ...(encodeDd ? { dd: base64_encode(JSON.stringify(dd)) } : {}),
        tk,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleHistoryCteError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestHistoryCtePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'deleteMarcador':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'deleteMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downXML':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'dwnXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLote':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 1 },
      });
    case 'downloadLoteTodas':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'downloadLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmail':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'enviaArquivosEmail',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmailTodos':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'enviaArquivosEmailTodos',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'eventos':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 1 },
      });
    case 'hideMarcador':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'hideMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'investigar':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'investigar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'manifestacao':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'manifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqCte':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'pesqCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'printDacte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'printDacte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadDacteZip':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'downloadDacteZip',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printDaEventoCte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'printDaEventoCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaConfigTabela':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });
    case 'salvaNovoMarcador':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'salvaNovoMarcadorCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 'cte' },
      });
    case 'setMarcador':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'showMarcador':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'showMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'situacao':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });
    case 'updateAnotacao':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'getHistoricoDownloads':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'getHistoricoDownloads',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'gerarLinkDownload':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'gerarLinkDownload',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'salvarObservacao':
      return ajaxHistoryCteEvent({
        type: 'Post',
        ll: 'salvarObservacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistoryCteGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableCte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getConfigTableCte',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'getTableCte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getTableCte',
        dd: null,
        tk: token,
        parseType: 'raw',
        routeField: 'act',
        encodeDd: false,
        extraData: { key: emp, ukey: uid },
      });
    case 'getMarcadores':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getMarcadores',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getVinculados':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getVinculadosCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getHistoricoConsumoCte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getHistoricoConsumoCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getDetalhesNotasCte':
      return ajaxHistoryCteEvent({
        type: 'Get',
        ll: 'getDetalhesNotasCte',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistoryCtePost, RestHistoryCteGet };
